import GEFormFields from '@/Types/GEFormFields';
import SchemaField from '@/Types/SchemaField';
import IfCallbackResolverService from '@/Services/IfCallbackResolverService';
import RulesTransformer from '@/Services/RulesTransformer';
import WrappedUploadInput from '@/Components/Input/WrappedUploadInput.vue';
import formulateUploaderFactory, {
    FormulateUploader,
} from '@/utils/formulate-uploader';

export default class SchemaService {
    private readonly schema: any;
    private readonly fields: GEFormFields;
    constructor(schema: any, fields: GEFormFields) {
        this.schema = schema;
        this.fields = fields;
    }

    process() {
        return this.schema.map(({ if: ifCallbackString, ...processed }: SchemaField) => {
            const { name, component } = processed;

            const ifCallback = ifCallbackString ? IfCallbackResolverService.resolve(ifCallbackString) : null;

            if (ifCallback && !ifCallback(this.fields)) {
                return null;
            }

            if (component === WrappedUploadInput.COMPONENT_NAME) {
                processed.uploader = formulateUploaderFactory(name)
            }

            this.mapFields(processed);

            return processed;
        }).filter((val: SchemaField) => !!val)
    }

    private mapFields(field: SchemaField): void {
        Object.entries(field)
            .forEach(([key, _value]) => {
            if (key === 'value') {
                const _value = field[key];
                if (typeof _value === 'string') {
                    const [,fieldName] = _value.match(/^field:(.*)/) || [];
                    if (this.fields[fieldName] && this.fields[fieldName].length) {
                        field[key] = this.fields[fieldName];
                    }
                }
            }

            const value = field[key];

            const isUploader = (value: any): value is FormulateUploader => key === 'uploader';
            if (!isUploader(value) && typeof value === 'function') {
                field[key] = value(this.fields);
            }

            if (key.match(/validation$/i) && (typeof value === 'string' || Array.isArray(value))) {
                field[key] = (new RulesTransformer(value)).getTransformed();
            }
            })
    }
}

